import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, isRef as _isRef } from "vue"

const _hoisted_1 = { name: "CreateEditNotice" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-11 offset-1" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-11 offset-1" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-11 offset-1" }
const _hoisted_9 = { class: "hstack gap-2 w-100" }
const _hoisted_10 = {
  class: "form-check ps-0",
  style: {"width":"11em"}
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "hstack gap-2 w-100 mt-2" }
const _hoisted_14 = {
  class: "form-check ps-0",
  style: {"width":"11em"}
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "row mt-2" }
const _hoisted_18 = { class: "col-8" }
const _hoisted_19 = {
  tabindex: "-1",
  class: "tagwidth-150 text-truncate"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_22 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_23 = { class: "col-8" }
const _hoisted_24 = {
  tabindex: "-1",
  class: "tagwidth-150 text-truncate"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_27 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_28 = { class: "col-8 align-content-center" }
const _hoisted_29 = { class: "row mt-2" }
const _hoisted_30 = { class: "col-8" }
const _hoisted_31 = { class: "row mt-2" }
const _hoisted_32 = { class: "col-8" }
const _hoisted_33 = { class: "row mt-2" }
const _hoisted_34 = { class: "col-sm-12" }
const _hoisted_35 = { class: "hstack gap-2 align-end" }
const _hoisted_36 = ["disabled"]

import SelectField from "@/components/Misc/SelectField.vue";

import Datepicker from "@vuepic/vue-datepicker";
import {useScheduledNoticeStore} from "@/stores/scheduledNoticeStore";
import {useOriStore} from "@/stores/oriStore";
import {useFormValidation} from "@/validation";
import {computed, onMounted, ref, watch} from "vue";
import {NoticeModel, NotificationEmailType, ScheduledItem} from "./types";
import {Ori, SelectItem} from "../../types";
import {BSelect, BInput, BTextarea, BAgency} from "../Fields";
import {array, date, object, string} from "yup";
import Multiselect from "@vueform/multiselect";
import InformationModal from "../Misc/InformationModal.vue";
const dateFormat = "yyyy-MM-dd";

export default /*@__PURE__*/_defineComponent({
  __name: 'CreateEditNotice',
  props: {
    item: {},
    title: {},
    showModal: { type: Boolean }
  },
  emits: ["dismiss", "submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const scheduledNoticeStore = useScheduledNoticeStore();
const oriStore = useOriStore();
const recipientMode = ref("agency" as "agency" | "condition");
const notice = ref(new NoticeModel(props.item));
const emit = __emit;
const allOris = ref([] as Ori[]);
var submitDisabled = ref(false);
const isEditMode = computed(() => {
    return props.item?.id > 0;
});
var showCreateNoticeModal = ref(false);
const schema = object<NoticeModel>({
    headline: string().required().label("Headline"),
    scheduleNotification: date().required().label("Run Date"),
    emailRecipients: array().required().min(1).label("Email Notice to"),
    agency: array()
        .label("Agency")
        .nullable()
        .when([], {
            is: () => recipientMode.value == "agency",
            then: (schema) => schema.required().min(1),
        }),
    condition: string()
        .label("Condition")
        .nullable()
        .when([], {
            is: () => recipientMode.value == "condition",
            then: (schema) => schema.required(),
        }),
});

const {handleSubmit, errors} = useFormValidation();
async function submitNotice() {
    submitDisabled.value = true;

    if (await handleSubmit(schema, notice.value)) {
        if (props.item?.id > 0) {
            await scheduledNoticeStore.editScheduledTask(props.item.id, notice.value);
        } else {
            await scheduledNoticeStore.createScheduledTask(notice.value);
        }

        await scheduledNoticeStore.getScheduledNotices();

        handleDismiss();        
    }
    
    submitDisabled.value = false;
}

function handleDismiss() {
    emit("dismiss");
}

async function handleDelete() {
    if (props.item?.id > 0) {
        await scheduledNoticeStore.deleteScheduledTask(props.item.id);
    }

    await scheduledNoticeStore.getScheduledNotices();

    handleDismiss();
}

function handleClear() {
    notice.value.emailRecipientsArray = [] as NotificationEmailType[];
}

onMounted(async () => {
    
    submitDisabled.value = false;
    scheduledNoticeStore.getConditions();
    scheduledNoticeStore.getRepeatOptions();
    scheduledNoticeStore.getEmailRecipients();
    scheduledNoticeStore.getAvailableReports();
});

watch(
    () => props.item,
    () => {
        notice.value = new NoticeModel(props.item);

        if (props.item.type != null && props.item.type != 1) {
            recipientMode.value = "condition";
        } else {
            recipientMode.value = "agency";
        }
    }
);

watch(recipientMode, () => {
    if (recipientMode.value == "agency") {
        notice.value.condition = undefined;
    } else {
        notice.value.agency = undefined;
    }
});

watch(
    () => props.showModal,
    (val) => {
       showCreateNoticeModal.value = props.showModal;
    },
    { immediate: true }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(InformationModal, {
      title: __props.title,
      modelValue: _unref(showCreateNoticeModal),
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(showCreateNoticeModal) ? (showCreateNoticeModal).value = $event : showCreateNoticeModal = $event)),
      "show-footer": true,
      width: "35.5em",
      onDismiss: _cache[14] || (_cache[14] = ($event: any) => (handleDismiss()))
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("div", { class: "col" }, [
              _createElementVNode("label", {
                for: "headline",
                "aria-label": "Subject line of the notice"
              }, "Headline:")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(BInput), {
                name: "headline",
                type: "text",
                error: _unref(errors).headline,
                required: "required",
                modelValue: notice.value.headline,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((notice.value.headline) = $event))
              }, null, 8, ["error", "modelValue"])
            ])
          ]),
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "row mt-2" }, [
            _createElementVNode("div", { class: "col" }, [
              _createElementVNode("label", {
                for: "body",
                "aria-label": "Main content of the notice",
                class: "align-middle"
              }, "Body:")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(BTextarea), {
                name: "body",
                "aria-required": "true",
                required: "required",
                modelValue: notice.value.body,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((notice.value.body) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "row mt-2" }, [
            _createElementVNode("div", { class: "col align-content-center" }, [
              _createElementVNode("label", null, "Select Recipients by:")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    id: "recipientAgencyRadio",
                    name: "recipientRadio",
                    type: "radio",
                    value: "agency",
                    disabled: isEditMode.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((recipientMode).value = $event))
                  }, null, 8, _hoisted_11), [
                    [_vModelRadio, recipientMode.value]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label ps-2",
                    for: "recipientAgencyRadio",
                    disabled: isEditMode.value
                  }, "Agency:", 8, _hoisted_12)
                ]),
                _createVNode(SelectField, {
                  class: "w-100",
                  modelValue: notice.value.agency,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((notice.value.agency) = $event)),
                  "select-items": _unref(oriStore).getOrisForSelectList,
                  mode: "multiple",
                  error: _unref(errors).agency,
                  min: 1,
                  "include-show-all-option": true,
                  "hide-selected": false,
                  "close-on-select": false,
                  "is-disabled": recipientMode.value != 'agency'
                }, null, 8, ["modelValue", "select-items", "error", "is-disabled"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    id: "recipientConditionRadio",
                    name: "recipientRadio",
                    type: "radio",
                    value: "condition",
                    disabled: isEditMode.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((recipientMode).value = $event))
                  }, null, 8, _hoisted_15), [
                    [_vModelRadio, recipientMode.value]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label ps-2",
                    for: "recipientConditionRadio",
                    disabled: isEditMode.value
                  }, "Condition:", 8, _hoisted_16)
                ]),
                _createVNode(SelectField, {
                  class: "w-100",
                  modelValue: notice.value.condition,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((notice.value.condition) = $event)),
                  mode: "single",
                  "select-items": _unref(scheduledNoticeStore).conditions,
                  error: _unref(errors).condition,
                  "is-disabled": isEditMode.value || recipientMode.value != 'condition'
                }, null, 8, ["modelValue", "select-items", "error", "is-disabled"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-4 align-content-center" }, [
              _createElementVNode("label", null, "Email Notice to:")
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_unref(Multiselect), {
                modelValue: notice.value.emailRecipientsArray,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((notice.value.emailRecipientsArray) = $event)),
                options: _unref(scheduledNoticeStore).emailRecipients,
                mode: 'tags',
                "close-on-select": false,
                label: 'label',
                rules: ['min:1'],
                "native-support": true,
                "can-clear": true,
                "hide-selected": true,
                "open-direction": "bottom",
                autocomplete: "n/a",
                onClear: _withModifiers(handleClear, ["prevent"]),
                classes: {
                                    tag: 'text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center tagwidth-100 text-truncate rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1',
                                }
              }, {
                tag: _withCtx(({option, handleTagRemove, disabled}) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["multiselect-tag", {
                                            'is-disabled': disabled,
                                        }])
                  }, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "d-inlineblock hstack bg-secondary text-white text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1" }, null, -1)),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(option.label), 1),
                    (!disabled)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "multiselect-tag-remove",
                          onClick: _withModifiers(($event: any) => (handleTagRemove(option, $event)), ["prevent"])
                        }, [...(_cache[15] || (_cache[15] = [
                          _createElementVNode("span", { class: "multiselect-tag-remove-icon" }, null, -1)
                        ]))], 8, _hoisted_20))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["modelValue", "options"]),
              (_unref(errors).emailRecipients)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(errors).emailRecipients), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (_unref(scheduledNoticeStore).availableReports?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-4" }, [
                  _createElementVNode("label", null, "Attach Report(s):")
                ], -1)),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_unref(Multiselect), {
                    modelValue: notice.value.reports,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((notice.value.reports) = $event)),
                    options: _unref(scheduledNoticeStore).availableReports,
                    mode: 'tags',
                    "close-on-select": false,
                    label: 'label',
                    rules: [],
                    "native-support": true,
                    "can-clear": true,
                    "hide-selected": true,
                    "open-direction": "bottom",
                    autocomplete: "n/a",
                    onClear: _withModifiers(handleClear, ["prevent"]),
                    classes: {
                                    tag: 'text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center tagwidth-100 text-truncate rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1',
                                }
                  }, {
                    tag: _withCtx(({option, handleTagRemove, disabled}) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["multiselect-tag", {
                                            'is-disabled': disabled,
                                        }])
                      }, [
                        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "d-inlineblock hstack bg-secondary text-white text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1" }, null, -1)),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(option.label), 1),
                        (!disabled)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "multiselect-tag-remove",
                              onClick: _withModifiers(($event: any) => (handleTagRemove(option, $event)), ["prevent"])
                            }, [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("span", { class: "multiselect-tag-remove-icon" }, null, -1)
                            ]))], 8, _hoisted_25))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options"]),
                  (_unref(errors).reports)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(errors).reports), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (props.item?.id > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-4 align-content-center" }, [
                  _createElementVNode("label", null, " Most Recent Execution Date:")
                ], -1)),
                _createElementVNode("div", _hoisted_28, _toDisplayString(props.item.last_run?.replace("0001-01-01", "")), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-4 align-content-center" }, [
              _createElementVNode("label", null, "Run Date:")
            ], -1)),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_unref(Datepicker), {
                modelValue: notice.value.scheduleNotification,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((notice.value.scheduleNotification) = $event)),
                format: dateFormat,
                clearable: false,
                required: "",
                "input-class-name": "form-control",
                "aria-label": "Schedule notification",
                "enable-time-picker": false,
                utc: "preserve",
                "text-input": "",
                "prevent-min-max-navigation": "",
                "start-date": new Date(Date.now()),
                exactMatch: ""
              }, null, 8, ["modelValue", "start-date"])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-4 align-content-center" }, [
              _createElementVNode("label", { for: "repeat" }, "Repeat:")
            ], -1)),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(SelectField, {
                "can-clear": false,
                modelValue: notice.value.repeat,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((notice.value.repeat) = $event)),
                "select-items": _unref(scheduledNoticeStore).repeatOptions,
                "is-required": true,
                "open-direction": "top"
              }, null, 8, ["modelValue", "select-items"])
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              (props.item?.id > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-danger width-75 margin-right-5",
                    onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (handleDelete()), ["prevent"]))
                  }, " Delete "))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-secondary width-75",
                onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (handleDismiss()), ["prevent"]))
              }, " Cancel "),
              _createElementVNode("button", {
                disabled: _unref(submitDisabled),
                class: "btn btn-primary width-75",
                onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (submitNotice()), ["prevent"]))
              }, " Save ", 8, _hoisted_36)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}
}

})